import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaGalleryComponent } from './media-gallery/media-gallery.component';
import { DropMenuModule } from '../drop-menu/drop-menu.module';
import { MediaGalleryListComponent } from './media-gallery-list/media-gallery-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FamilyProjectListComponent } from './family-project-list/family-project-list.component';


@NgModule({
  declarations: [MediaGalleryComponent, MediaGalleryListComponent, FamilyProjectListComponent],
  imports: [
    CommonModule,
    DropMenuModule,
    SharedModule
  ],
  exports : [MediaGalleryComponent, MediaGalleryListComponent, FamilyProjectListComponent]
})
export class MediaGalleryModule { }
